import { render } from "./OrderStatusCellRenderer.vue?vue&type=template&id=1333fad4"
import script from "./OrderStatusCellRenderer.vue?vue&type=script&lang=js"
export * from "./OrderStatusCellRenderer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__